import * as n from "react";
const o = /* @__PURE__ */ n.createContext(void 0), i = ({
  children: r,
  size: e
}) => {
  const t = n.useContext(o);
  return /* @__PURE__ */ n.createElement(o.Provider, {
    value: e || t
  }, r);
};
function c(r, e) {
  var t = Object.assign({}, r);
  return Array.isArray(e) && e.forEach(function(a) {
    delete t[a];
  }), t;
}
export {
  o as S,
  i as a,
  c as o
};
